import toCurrency from '@/shared/directive/toCurrency';

interface RangeBand {
  quantidade?: number | string;
  valor?: number | string;
}

export default class ReadjustmentRuleParameterHistory {
  newValue: string;

  previous: string

  parameter: string;

  constructor(obj: any = {}) {
    this.newValue = obj.newValue || '';
    this.previous = obj.previous || '';
    this.parameter = obj.parameter || '';
  }

  public static of(obj: any = {}): ReadjustmentRuleParameterHistory {
    return new ReadjustmentRuleParameterHistory(obj);
  }

  public static ofList(obj: any[]): ReadjustmentRuleParameterHistory[] {
    return obj.map(this.of)
  }

  get isRange(): boolean {
    return ReadjustmentRuleParameterHistory.parseRange(this.newValue) !== null
      || ReadjustmentRuleParameterHistory.parseRange(this.previous) !== null;
  }

  get newValueRanges(): string[] {
    return ReadjustmentRuleParameterHistory.formatRange(this.newValue);
  }

  get previousRanges(): string[] {
    return ReadjustmentRuleParameterHistory.formatRange(this.previous);
  }

  private static parseRange(value: string): RangeBand[] | null {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : null;
    } catch {
      return null;
    }
  }

  private static formatRange(value: string): string[] {
    const bands = ReadjustmentRuleParameterHistory.parseRange(value);
    if (!bands) return [];
    return bands.map((band) => {
      const valor = toCurrency(band.valor);
      return band.quantidade != null ? `Quantidade ${band.quantidade}: ${valor}` : valor;
    });
  }
}
